module.exports = __webpack_public_path__ + "static/media/MagicVision.845c1fe4.png";